import { render } from "./DescriptionPreview.vue?vue&type=template&id=24371d1a&scoped=true"
import script from "./DescriptionPreview.vue?vue&type=script&lang=js"
export * from "./DescriptionPreview.vue?vue&type=script&lang=js"

import "./DescriptionPreview.vue?vue&type=style&index=0&id=24371d1a&scoped=true&lang=css"
import "./DescriptionPreview.vue?vue&type=style&index=1&id=24371d1a&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24371d1a"]])

export default __exports__